import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setScreenType } from '../ImageLibrary/redux/actions';

export type WizardConfig = {
    showEditorScreen: boolean,
    showFabricSelectorScreen: boolean,
    showTileSelectorScreen: boolean,
    skipWizard?: boolean,
    showBackButton: boolean
}

export type WizardScreenType = 'TilesSelector' | 'FabricSelector' | 'EditorScreen'|'reset'

export const useFabricWizard = (screenType?: WizardScreenType): WizardConfig | undefined => {
    const showFabricWizard = useSelector((state: any) => state.fbdata?.fabricWizard);
    const curImg = useSelector((state: any) => state.currentImg);
    const mediaLibImage = useSelector((state: any) => state.mediaLibTitle);
    const product = useSelector((state: any) => state.product);
    const currentProduct = product.isCurrentFabric ? product : null;

    const [newConfig, setNewConfig] = useState(undefined as WizardConfig | undefined)

    useEffect(() => {
        if(screenType === 'reset'){
            setNewConfig({
                showEditorScreen: false,
                showFabricSelectorScreen: true,
                showTileSelectorScreen: false,
                showBackButton: false
            })
            return;
        }
        if (showFabricWizard && !newConfig?.showEditorScreen) {
            if (currentProduct && (curImg || mediaLibImage) && !screenType) {
                const config = {
                    showEditorScreen: true,
                    showFabricSelectorScreen: false,
                    showTileSelectorScreen: false,
                    showBackButton: false
                }
                setNewConfig(config)
            } else if (!currentProduct && (curImg || mediaLibImage)) {
                const config = {
                    showEditorScreen: screenType === 'FabricSelector',
                    showFabricSelectorScreen: !screenType,
                    showTileSelectorScreen: false,
                    showBackButton: false
                }
                setNewConfig(config)
            } else if (currentProduct && !curImg && !mediaLibImage) {
                const config = {
                    showEditorScreen: screenType === 'TilesSelector',
                    showFabricSelectorScreen: false,
                    showTileSelectorScreen: !screenType,
                    showBackButton: false
                }
                setNewConfig(config)
            } else {
                if (!currentProduct && !curImg && !mediaLibImage) {
                    if (!screenType) {
                        setNewConfig({
                            showEditorScreen: false,
                            showFabricSelectorScreen: true,
                            showTileSelectorScreen: false,
                            showBackButton: false
                        })
                    } else if (screenType === 'FabricSelector') {
                        setNewConfig({
                            showEditorScreen: false,
                            showFabricSelectorScreen: false,
                            showTileSelectorScreen: true,
                            showBackButton: true
                        })
                    } else if (screenType === 'TilesSelector') {
                        setNewConfig({
                            showEditorScreen: true,
                            showFabricSelectorScreen: false,
                            showTileSelectorScreen: false,
                            showBackButton: true
                        })
                    } else if (screenType === 'EditorScreen') {
                        setNewConfig({
                            skipWizard: true,
                            showEditorScreen: true,
                            showFabricSelectorScreen: false,
                            showTileSelectorScreen: false,
                            showBackButton: true
                        })
                    }
                }
            }
        } else {
            setNewConfig(newConfig?.showEditorScreen ? {
                skipWizard: true,
                showEditorScreen: true,
                showFabricSelectorScreen: false,
                showTileSelectorScreen: false,
                showBackButton: true
            } : undefined)
        }

    }, [currentProduct, curImg, showFabricWizard, screenType])


    // console.log("==fabric wizard=1===>", {...newConfig, screenType});

    return newConfig
}